module.exports = __webpack_public_path__ + "fonts/DrukCondensed-Super.fe7fac8.ttf";